module.exports = __webpack_public_path__ + "static/media/Manjaro_wallpaper.120b3e59.png";